import classes from "./Overlay.module.css";
import {useContext} from "react";
import CreateQRCodeContext from "../../CreateQRCodeContext";
import {Button} from "@mantine/core";

/**
 * Overlay to be use in CreateQRCodeView.
 * It will be floating at the bottom of the page and shows the 'Next' button.
 * @constructor
 */
function Overlay() {
    /**
     * CreateQRCodeContext
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    /**
     * Check if 'Next page' button should be disabled.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const isButtonDisabled = () => {
        return ctx.step == 'input-data' || ctx.kind === null; // TODO: Should be more of this.
    };

    /**
     * Go to the next step.
     * Changes CreateQRCodeContext-step value.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const goNextStep = () => {
        if (ctx.step == 'choose-kind') {
            ctx.setStep('input-data');
            return;
        }

        throw new Error('There\'s no more steps after `input-data`');
    }

    /**
     * On button is clicked.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const onButtonClicked = () => {
        goNextStep();
    }

    return (
        <div className={classes.root}>
            <Button
                className={classes.button}
                size="lg"
                children="Dalej"
                disabled={isButtonDisabled()}
                onClick={onButtonClicked}
            />
        </div>
    );
}

export default Overlay;